var ContextType;
(function (ContextType) {
    ContextType["DATA"] = "Data";
    ContextType["SUBMITTABLE_FRAGMENT"] = "SubmittableFragment";
})(ContextType || (ContextType = {}));
export { ContextType, };
//# sourceMappingURL=constants.js.map